import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { StorageConstants, RoutesConstants } from "../constants";
import { StorageHelper } from "../helpers";
import { ApiService } from "../services/api.service";

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const apiKey =
    ApiService.apiKey() ||
    (StorageHelper.getItem(StorageConstants.API_KEY) as string | null);

  if (apiKey) {
    req = req.clone({
      setHeaders: { 'Api-Key': ` ${apiKey}` },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {

        ApiService.apiKey.set(null);
        StorageHelper.removeItem(StorageConstants.API_KEY);

        router.navigate([RoutesConstants.HOME]);

      } else if (error instanceof HttpErrorResponse) {
        const message = error.error?.message || 'Unexpected error occurred';
        snackBar.open(message, undefined, { duration: 3000 });
      }
      return throwError(() => error);
    })
  );
};